import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";

import endPoints from "./messages.endpoints";

import { CreateMessageRequestDto } from "./messages.requestsDto";

import { ApiCallResult } from "../../../../types";

import MessageDto from "../../../../../dto/Message/MessageDto";

const backOfficeMessagesApi = {
  create: function* (dto: CreateMessageRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.controller, dto)) as ApiCallResult<MessageDto>;
  },
};

export default backOfficeMessagesApi;
